
import {Component, Vue, Prop} from 'vue-property-decorator';
import * as echarts from 'echarts';
import {statisticsApi} from '@/api';
import moment from 'moment';
import EchartsTooltip from './EchartsTooltip.vue';
import Empty from '@/components/Empty/index.vue';
const chartTooltip = Vue.extend(EchartsTooltip);

@Component({
    components: {
        Empty
    }
})
export default class TeachingSitutation extends Vue {
    searchQuery = {
        type: 'courseCount'
    };
    chart = {};
    option = {};
    initChart() {
        const chartDom: HTMLElement | null = document.querySelector('#chart');
        if (chartDom) {
            this.chart = echarts.init(chartDom, undefined, {renderer: 'svg'});
            (this.chart as echarts.ECharts).clear();
            this.option = {
                color: ['#1456ED', '#2D85FF', '#17C980', '#FFCB22', '#FF7E1A', '#E53933', '#D73AB2', '#7831D4', '#5D7092'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    borderColor: '#EBEDF0',
                    padding: 16,
                    enterable: true,
                    formatter: (params: any) => {
                        const index = params.findIndex((x: any) => x.seriesName);
                        if (this.hasData > -1 && index > -1) {
                            const com = new chartTooltip() as EchartsTooltip;
                            com.setData({params, dateType: this.formatDateType, tooltipsType: 'teachingSituation'});
                            com.$mount();
                            return com.$el.innerHTML;
                        } else {
                            return '';
                        }
                    }
                },
                legend: {
                    show: true,
                    bottom: 14,
                    icon: 'circle',
                    align: 'auto',
                    itemWidth: 8,
                    itemHeight: 8,
                    itemGap: 32,
                    type: 'scroll',
                    textStyle: {
                        rich: {
                            a: {
                                verticalAlign: 'middle'
                            }
                        },
                        padding: [0, 0, 2, 0]
                    }
                },
                grid: {
                    left: 0,
                    bottom: 48,
                    right: 24,
                    top: 32,
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    axisTick: {
                        show: true,
                        alignWithLabel: true
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#EBEDF0'
                        }
                    },
                    axisLabel: {
                        show: true,
                        color: 'rgba(0,0,0,0.6)',
                        showMinLabel: true,
                        margin: 24,
                        formatter: (val: string) => {
                            if (this.formatDateType === 'month') {
                                return moment(val).format('YYYY.MM');
                            } else {
                                return moment(val).format('YYYY/MM/DD');
                            }
                        }
                    }
                },
                yAxis: [
                    {
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#EBEDF0'
                            }
                        },
                        type: 'value',
                        axisLabel: {
                            color: 'rgba(0,0,0,0.6)'
                        },
                        splitNumber: 5,
                        max: () => {
                            if (this.autoMax) {
                                return this.searchQuery.type === 'courseCount' ? 10 : 5;
                            } else {
                                return null;
                            }
                        }
                    }
                ],
                series: this.courseCountData
            };
            this.$nextTick(() => {
                (this.chart as echarts.ECharts).resize();
            });

            (this.chart as echarts.ECharts).setOption(this.option);
            window.addEventListener('resize', () => {
                (this.chart as echarts.ECharts).resize();
            });
        }
    }

    courseCountData: any = [];
    fromDate = '';
    formatDateType = 'day';
    XAixs: {}[] = [];
    onChange(val?: any) {
        if (val.target.value === 'year') {
            this.XAixs = this.getMonths(12);
        } else if (val.target.value === 'month') {
            this.XAixs = this.getDays(30);
        } else if (val.target.value === 'halfYear') {
            this.XAixs = this.getMonths(6);
        } else {
            this.XAixs = this.getDays(7);
        }
        this.getData();
    }

    onDataType(val: any) {
        this.getData();
    }
    getDays(day: number) {
        const dates = [];
        const NUM_OF_DAYS = day;

        this.formatDateType = 'day';
        this.fromDate = moment()
            .subtract(day - 1, 'day')
            .format('YYYY-MM-DD 00:00:00');
        for (let i = 0; i < NUM_OF_DAYS; i++) {
            const date = moment().subtract(i, 'day').format('YYYY-MM-DD');
            dates.push({value: date});
        }
        return dates.reverse();
    }
    getMonths(month: number) {
        const dates = [];
        const NUM_OF_MONTHS = month;

        this.formatDateType = 'month';
        this.fromDate = moment()
            .subtract(month - 1, 'month')
            .format('YYYY-MM-DD 00:00:00');

        for (let i = 0; i < NUM_OF_MONTHS; i++) {
            const date = moment().subtract(i, 'month').format('YYYY-MM');
            dates.push({value: date});
        }
        return dates.reverse();
    }
    hasData = -1;
    getData() {
        const urlQueryParmas = {
            startTime: this.fromDate,
            endTime: moment().format('YYYY-MM-DD 24:00:00'),
            unit: this.formatDateType
        };
        const api = this.searchQuery.type === 'courseCount' ? 'getTeacherClassCount' : 'getTeacherClassTime';
        statisticsApi[api]({
            context: this,
            urlQueryParmas,
            success: (data: any) => {
                if (data.code === 0) {
                    const tempData = data.data.results
                        .map((item: {plans: any[]; countTime: any}) => {
                            if (item.plans.length) {
                                item.plans.forEach(child => {
                                    child.countTime = moment(item.countTime).format(
                                        this.formatDateType === 'day' ? 'YYYY/MM/DD' : 'YYYY.MM'
                                    );
                                    child.data = [];
                                });
                            } else {
                                item.plans[0] = {
                                    countTime: moment(item.countTime).format(this.formatDateType === 'day' ? 'YYYY/MM/DD' : 'YYYY.MM'),
                                    data: []
                                };
                            }

                            return item.plans;
                        })
                        .flat();
                    if (!tempData.length) {
                        this.courseCountData = [
                            {
                                name: '',
                                type: 'bar',
                                data: data.data.results.map((child: any) => {
                                    if (this.searchQuery.type === 'courseCount') {
                                        return [
                                            moment(child.countTime).format(this.formatDateType === 'day' ? 'YYYY/MM/DD' : 'YYYY.MM'),
                                            0,
                                            0,
                                            this.searchQuery.type
                                        ];
                                    } else {
                                        const avgCourseDuration = 0;
                                        const totalCourseDuration = 0;
                                        return [
                                            moment(child.countTime).format(this.formatDateType === 'day' ? 'YYYY/MM/DD' : 'YYYY.MM'),
                                            totalCourseDuration / 3600,
                                            avgCourseDuration / 3600,
                                            this.searchQuery.type,
                                            {totalCourseDuration, avgCourseDuration}
                                        ];
                                    }
                                })
                            }
                        ];
                    } else {
                        this.formatData(tempData);
                    }
                    this.hasData = this.courseCountData.findIndex((x: {name: any}) => x.name);
                    this.$nextTick(() => {
                        this.initChart();
                    });
                }
            }
        });
    }
    autoMax: any = false;
    formatData(data: any[]) {
        var result = [];
        var flag = true;
        result.push(data[0]);
        for (var i = 1; i < data.length; i++) {
            flag = true;
            for (var j = 0; j < result.length; j++) {
                if (data[i].teacherId == result[j].teacherId) {
                    flag = false;
                    result[j].data.push(data[i]);
                }
            }
            if (flag) result.push(data[i]);
        }
        const maxData: any = [];
        this.courseCountData = result.map(item => {
            item.data.unshift(item);
            return {
                name: item.nickname,
                type: 'bar',
                emphasis: {
                    focus: 'series'
                },
                data: item.data.map((child: any) => {
                    if (this.searchQuery.type === 'courseCount') {
                        maxData.push(child.startClassCount || 0);
                        return [child.countTime, child.startClassCount || 0, child.classCount || 0, this.searchQuery.type];
                    } else {
                        maxData.push(child.totalCourseDuration || 0);
                        const avgCourseDuration = child.avgCourseDuration || 0;
                        const totalCourseDuration = child.totalCourseDuration || 0;
                        return [
                            child.countTime,
                            totalCourseDuration / 3600,
                            avgCourseDuration / 3600,
                            this.searchQuery.type,
                            {totalCourseDuration, avgCourseDuration}
                        ];
                    }
                })
            };
        });
        const maxCount = this.searchQuery.type === 'courseCount' ? 10 : 3600;
        if (Math.max(...maxData) <= maxCount) {
            this.autoMax = true;
        } else {
            this.autoMax = false;
        }
    }
    mounted() {
        this.onChange({target: {value: 'month'}});
    }
}
